import React, { Component } from 'react';

import ReactDOM from 'react-dom';
import swal from 'sweetalert';
import { API_URL,isEmpty,SendPasswordByMail,ShowSwallError,SwalUnBlokUI,SwalBlokUI } from '../../../config'
import $ from 'jquery'
import MaterialTable from 'material-table'
import { alpha } from '@material-ui/core/styles' 
import Swal from 'sweetalert2';
import Multiselect from 'multiselect-react-dropdown';
 
import BlockUi from 'react-block-ui';

import AsyncSelect from 'react-select/async';
  

 
class DistributorNew extends Component {
 
  tableRef = React.createRef();
    constructor(props) {
     
        super(props); 
        const grid_height= $(window).height()-$(".header-navbar").height()-200;
        this.max_body_heght= grid_height+"px"; 
         
        this.promiseOptions = this.promiseOptions.bind(this);
        this.state = {
          blocking: false,
          clicked_dist:"",
          options:[],
          user_id: { label: "Search Approver", value: "" }
        }
     
        //Newly added on 18th Jun 2024

        const RefreshLinedata = (custCode) => {
          Swal.fire({
            title: 'Partner Portal',
            text: 'Customer master sync with SAP',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel'
          }).then((result) => {
            if (result.isConfirmed) {
              if (result.isConfirmed) {
                const requestOptions = {
                  method: 'GET',
                  headers: { 'Content-Type': 'application/json', 'authorization': localStorage.getItem('token') },
                };
                let url = API_URL + "/distributor_master/UpdateDistributorDetails?cust_code=" + custCode;
                fetch(url, requestOptions)
                  .then(res => res.json())
                  .then(json => {
    
                    Swal.fire(json.data.msg);
    
                  })
                  .catch((e) => {
    
                  })
    
              }
    
    
            } else {
              console.log("Not Confirmed");
            }
    
    
    
          }
          );
    
        };
    
        const SyncBasePriceNational = (custCode) => {
          Swal.fire({
            title: 'Confirm Base Price National Sync',
            text: 'Click Yes to Start the Sync, Cancel to close the Window.',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel'
          }).then((result) => {
            if (result.isConfirmed) {
              if (result.isConfirmed) {
                const requestOptions = {
                  method: 'GET',
                  headers: { 'Content-Type': 'application/json', 'authorization': localStorage.getItem('token') },
                };
                let url = API_URL + "/distributor_master/UpdateDBBasePriceNational?cust_code=" + custCode;
                fetch(url, requestOptions)
                  .then(res => res.json())
                  .then(json => {
    
                    Swal.fire(json.data.msg);
    
                  })
                  .catch((e) => {
    
                  })
    
              }
            } else {
              console.log("Not Confirmed");
            }
    
          }
          );
    
    
    
    
        };
    
    
        const SyncCustomerChannelPrice = (custCode) => {
          Swal.fire({
            title: 'Confirm Customer Channel Price Sync',
            text: 'Click Yes to Start the Sync, Cancel to close the Window.',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel'
          }).then((result) => {
            if (result.isConfirmed) {
              if (result.isConfirmed) {
                const requestOptions = {
                  method: 'GET',
                  headers: { 'Content-Type': 'application/json', 'authorization': localStorage.getItem('token') },
                };
                let url = API_URL + "/distributor_master/UpdateCustomerChannelPrice?cust_code=" + custCode;
                fetch(url, requestOptions)
                  .then(res => res.json())
                  .then(json => {
    
                    Swal.fire(json.data.msg);
    
                  })
                  .catch((e) => {
    
                  })
    
              }
            } else {
              console.log("Not Confirmed");
            }
    
          }
          );
    
    
    
    
        };
    
        const SyncCustomerPriceListSAL = (custCode) => {
          Swal.fire({
            title: 'Confirm Customer Price List SAL Sync',
            text: 'Click Yes to Start the Sync, Cancel to close the Window.',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel'
          }).then((result) => {
            if (result.isConfirmed) {
              if (result.isConfirmed) {
                const requestOptions = {
                  method: 'GET',
                  headers: { 'Content-Type': 'application/json', 'authorization': localStorage.getItem('token') },
                };
                let url = API_URL + "/distributor_master/UpdateCustomerPriceListSAL?cust_code=" + custCode;
                fetch(url, requestOptions)
                  .then(res => res.json())
                  .then(json => {
    
                    Swal.fire(json.data.msg);
    
                  })
                  .catch((e) => {
    
                  })
    
              }
            } else {
              console.log("Not Confirmed");
            }
    
          }
          );
    
    
    
    
        };
    



        this.actions_button=[
          {
            icon: 'mail',
            tooltip: 'Send Login Password By Mail',
            onClick: (event, rowData) =>this.SendPasswordByMailByDistributorLogin(rowData["customer_code"])
          },
          {
            icon: () => (
                           
              <i class="fas fa-check-square"></i>
            ),
            tooltip: 'Select Approver',
            // onClick: (event, rowData) =>this.openApprovalPopUp(rowData["customer_code"])
            onClick: (event, rowData) =>{
              window.$("#approver-modal").modal("show");
              this.setState({ clicked_dist: rowData["customer_code"] })  
              this.setState({ user_id: { label: "Search Approver", value: "" }})
               if(!isEmpty(rowData["appr_name"]))
              {
                this.setState({ user_id: { label:rowData["appr_code"]+" - "+rowData["appr_name"], value: rowData["appr_code"] }})
              }
              
            }
          },
          {
            icon: () => (
    
              <i class="fa fa-spinner"></i>
            ),
            tooltip: 'Refresh This Distributor Data',
            onClick: (event, rowData) => { RefreshLinedata(rowData["customer_code"]) }
          },
          {
            icon: () => (
    
              <i class="fa fa-door-open"></i>
            ),
            tooltip: 'Refresh Base Price National for this DB',
            onClick: (event, rowData) => { SyncBasePriceNational(rowData["customer_code"]) }
          },
          {
            icon: () => (
    
              <i class="fa fa-dragon"></i>
            ),
            tooltip: 'Refresh Customer Channel Price for this DB',
            onClick: (event, rowData) => { SyncCustomerChannelPrice(rowData["customer_code"]) }
          },
          {
            icon: () => (
    
              <i class="fa fa-drum"></i>
            ),
            tooltip: 'Refresh Cust Price List SAL for this DB',
            onClick: (event, rowData) => { SyncCustomerPriceListSAL(rowData["customer_code"]) }
          }
        ]
        if(localStorage.getItem('userType')!="back office")
        this.actions_button=null

    }
    
    
     componentDidMount(){  
    console.clear() 
  
        
    }
    SendPasswordByMailByDistributorLogin(code)
    {
          
      Swal.fire({
        html: 'Do you want to Send Password to Distributor Mail',
       
        showCancelButton: true,
          cancelButtonColor:"#932708",
          confirmButtonColor:"#324081",
          confirmButtonText: 'Send Mail <i class="fas fa-check mr-50"></i> ',
          cancelButtonText: `Cancel <i class="fas fa-times-circle mr-50"></i> `,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
 
          SendPasswordByMail(code);
        } else if (result.isDenied) {
         // Swal.fire('Changes are not saved', '', 'info')
        }
      })
    }
    
    
     promiseOptions = (val) => 
      new Promise((resolve) => { 
          
          let arr=[]
          this.setState({ user_id: { label: "Search Approver", value: "" }})
          const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json','authorization': localStorage.getItem('token') }, 
        };
        if(isEmpty(val))
        val="";
        let url = API_URL + "/distributor_master/GetApproverAutoCompleteForDist?empCode="+val;
        fetch(url, requestOptions)
            .then(res => res.json())
            .then(json => {

              //  arr = [
              //   { value: 'ocean', label: 'Ocean', color: '#00B8D9', isFixed: true },
              //   { value: 'blue', label: 'Blue', color: '#0052CC', isDisabled: true },
              //   { value: 'purple', label: 'Purple', color: '#5243AA' }
              // ]
 
                resolve(json.data); 
            })
            .catch( (e) => {
 
                console.log(e)
            })
         
      });  
   
    submitApprover()
    {
      console.log(this.state);
        const requestOptions = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json','authorization': localStorage.getItem('token') }, 
      };
      let selected_user=this.state.user_id.value;
      if(isEmpty(selected_user))
      {
        ShowSwallError("Please Select User");
        return false;
      }
      SwalBlokUI("Please wait..");
      let url = API_URL + "/distributor_master/UpdateApproverForDist?empCode="+selected_user+"&clicked_dist="+this.state.clicked_dist
      fetch(url, requestOptions)
          .then(res => res.json())
          .then(json => {
            SwalUnBlokUI();
            if(json.hasOwnProperty("error"))
            {
                Swal.fire(
                    'Error',
                    json.status+"  "+json.error+"</br>"+json.message,
                    'warning'
                  )
                  console.clear();
            }
            else
            { 
            
            if(json.data.error_code==="0"){
                Swal.fire({
                    title: "Done!",
                    html: json.data.msg   ,
                    icon: "success",
                });
                console.clear();
             
                this.tableRef.current.onQueryChange();
                this.setState({ user_id: { label: "Search Approver", value: "" }})
                window.$("#approver-modal").modal("hide");
            }
            else {
                Swal.fire({
                    title: "OOPS!", 
                    html: json.data.msg   ,
                    icon: "warning",
                });
                console.clear();
            }
         }
        })
        .catch( (e) => {
            SwalUnBlokUI();
            Swal.fire({
                title: "OOPS!..",
                html: e,                  
                icon: "warning",
            });
            console.log(e)
        })
    }
    handleUserIdChange(value) {
      
      this.setState({ user_id: value }) 
  
    }
    HandleKeyPress=(event) => {
      if(event.key==="Backspace" || event.key==="Delete" )
      {
        this.setState({ user_id: { label: "Search Approver", value: "" }})
      }
    }
  
    render() {
 
        return (
          <>
            <div className="App">
             
              <MaterialTable  style={{border: '0px solid red'}}   tableRef={this.tableRef}
                title="Active Distributor Listing" minRows={10}
                columns={ [
                  { title: "Dist Code", field: "customer_code" },
                  { title: "Dist Name", field: "customer_name" },              
                  { title: "Phone", field: "phone_no1" },
                  { title: "Mail ID", field: "email_id" },
                  { title: "GSTIN", field: "gstin" },
                  { title: "Mapped SR", field: "mapped_sr" },
                  { title: "Approver", field: "appr_name" },
                  { title: "Status", field: "customer_status" },                  
                  { title: "Location Code", field: "location_code" },
                  { title: "SAP Territory", field: "sap_territory" },
                  { title: "PAN", field: "pan" },
                  { title: "TCS Applicable", field: "tcs_applicable" },
                  { title: "Price Channel", field: "price_page_code" },
                  { title: "Price Sub Channel", field: "sap_channel" },
                  { title: "Price Cust Channel", field: "customer_channel" },
                  { title: "Block Sale Flag", field: "block_sale" }

                  
                ]}
                options={{maxBodyHeight: this.max_body_heght, debounceInterval: 700, padding: "dense", filtering: false,
                exportButton: true,
                headerStyle: {
                  position: "sticky",
                  top: "0",
                  backgroundColor: "#64a179",
                  color: "#FFF",
                  fontSize: "0.9em"
                },
                rowStyle: (rowData) => ({
                  fontSize: "1em",
                  backgroundColor:
                    rowData.tableData.id % 2 === 1 ? "#e8f5e2" : "#ffffff"
                }),
                      pageSize: 10,
                      pageSizeOptions: [50, 100 ,150, 200, 250,300],
                      toolbar: true,
                      paging: true 
                }}

                
                data={query =>
                  new Promise((resolve, reject) => {
                    // prepare your data and then call resolve like this:
                    let url = API_URL+'/distributor_master/GetDistributorGridData?'
                    let q_search="";
                    let sort="";
                    let order_by="";
                    //searching
                    if (query.search) {
                        q_search=`${query.search}`;
                    }
                    //sorting 
                    if (query.orderBy) {
                        sort= `${query.orderBy.field}`;
                        order_by=`${query.orderDirection}`
                    }
                    url += "&q_search="+q_search
                    url += "&sort="+sort
                    url += "&order_by="+order_by

                    //filtering
                    if (query.filters.length) {
                      const filter = query.filters.map(filter => {
                        return `&${filter.column.field}${filter.operator}${filter.value}`
                      })
                      url += filter.join('')
                    }
                    //pagination
                    url += `&page=${query.page + 1}`
                    url += `&limit=${query.pageSize}`
                    // console.clear();

                     //request options
                     const requestOptions = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': localStorage.getItem('token')
                        },
                        // body: JSON.stringify(data1)
                    };

                    fetch(url,requestOptions).then(resp => resp.json()).then(resp => {
                      resolve({
                        data: resp['data']['data'],// your data array
                        page: query.page,// current page number
                        totalCount:  resp['data']['total_records']// total row number
                      });
                     

                    })
        
                  })
                }
                actions={this.actions_button}
              />
            </div>




            <div class="modal" tabindex="-1" id="approver-modal">
                <div class="modal-dialog ">
                <BlockUi tag="div" blocking={this.state.blocking} message="Please wait" color="red" >
                    <form class=" modal-content ">
                        
                        <div class="modal-header ">
                            <h5 class="modal-title" id="exampleModalLabel">Approver</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                         
                        <div class="modal-body">
                        <div class="col-lg-8">
                            <label>Select Approver</label>
                            
                            

                            <AsyncSelect       value={this.state.user_id}  onKeyDown={this.HandleKeyPress}   onKeyPressss={this.HandleKeyPress} defaultOptions onChange={value => this.handleUserIdChange(value)}  cacheOptions   loadOptions={this.promiseOptions} />
                                                                      
                                                                        
                        </div> 
                        </div> 

                        <div class="modal-footer">
                          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                          <button type="button" class="btn btn-primary" onClick={() => this.submitApprover()}  >Submit</button>
                        </div>
                       
                    </form>
                    </BlockUi>
                </div>
            </div>
            </>
          );
         


    }
}
export default DistributorNew